<template>
  <Layer title="Re-open Order" @close="$emit('close')">
    <p v-if="isLoading" class="alert alert-secondary m-4">Loading closed orders...</p>
    <p v-else-if="orders.length === 0" class="alert alert-warning m-4">No recent orders founds</p>
    <ul v-else class="list-group">
      <li
        v-for="order in orders"
        :key="order.id"
        class="list-group-item d-flex justify-content-between align-items-center m-2"
      >
        <div class="text-truncate">
          <span class="text-truncate">{{ order.organizationName }}</span>
          <small class="d-block">{{ order.deliveryDate.toDate() | date }}</small>
        </div>
        <button class="btn btn-sm btn-outline-secondary flex-shrink-0" @click="reOpenorder(order.id)">Re-open</button>
      </li>
    </ul>
  </Layer>
</template>

<script>
import Layer from '@/shared/Layer'
import { db, fb } from '@/shared/firebase'

export default {
  components: { Layer },
  data() {
    return {
      orders: [],
      ordersSubscription: null,
      isLoading: true
    }
  },
  async beforeMount() {
    this.isLoading = true
    this.ordersSubscription = await db
      .collection('orders')
      .where('billingDocumentsGenerated', '==', false)
      .onSnapshot(snapshot => {
        const orders = snapshot.docs.map(doc => {
          return { ...doc.data(), id: doc.id }
        })
        this.orders = orders
          .filter(o => o.deliveryDate)
          .sort((a, b) => b.deliveryDate.toDate() - a.deliveryDate.toDate())
        setTimeout(() => {
          this.isLoading = false
        }, 250)
      })
  },
  beforeDestroy() {
    this.ordersSubscription()
  },
  methods: {
    reOpenorder(orderId) {
      db.doc(`orders/${orderId}`).update({
        deliveryDate: fb.firestore.FieldValue.delete(),
        state: 'preparing'
      })
    }
  },
  filters: {
    date(date) {
      return date.toLocaleString('de-DE', {
        hour: '2-digit',
        minute: '2-digit',
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
      })
    }
  }
}
</script>
